import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { DisabledDetailsState } from '@platform-frontend/account';
import { PLATFORM_MATOMO_EVENT_CATEGORY_LEGAL, YATTA_PRIVACY_POLICY_URL, YATTA_TERMS_OF_SERVICE_URL } from '@platform-frontend/platform';
import { YattaExternalLanguageSpecificLinkUrl } from '@platform-frontend/util';
import { MatomoTracker } from 'ngx-matomo-client';
import { Observable } from 'rxjs';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-accept-new-terms-ui',
  templateUrl: './accept-new-terms-ui.component.html',
  styleUrls: ['./accept-new-terms-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class AcceptNewTermsUiComponent implements OnInit {
  constructor(private store: Store, private matomoTracker: MatomoTracker) {}

  @Output()
  declineMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  acceptMethod: EventEmitter<void> = new EventEmitter();

  deleteDate$: Observable<Date | null> = this.store.select(DisabledDetailsState.deleteDate);
  readonly MATOMO_EVENT_CATEGORY_LEGAL = PLATFORM_MATOMO_EVENT_CATEGORY_LEGAL;

  TERMS_OF_SERVICE_URL: YattaExternalLanguageSpecificLinkUrl;
  PRIVACY_POLICY_URL: YattaExternalLanguageSpecificLinkUrl;

  ngOnInit(): void {
    this.TERMS_OF_SERVICE_URL = YATTA_TERMS_OF_SERVICE_URL;
    this.PRIVACY_POLICY_URL = YATTA_PRIVACY_POLICY_URL;
  }

  decline(): void {
    this.declineMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_LEGAL, 'Select_UpdateTermsAndPrivacy', 'Decline');
  }

  accept(): void {
    this.acceptMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_LEGAL, 'Select_UpdateTermsAndPrivacy', 'AcceptAndContinue');
  }
}
